import React from 'react';
import classNames from 'classnames';
import Formula from './Formula';
import Connective from './Connective';
import With from './With';
import Statement from '../Statement';

import Operator from '../components/Operator';
import Subformula from '../components/Subformula';

import styles from '../styles/Formula.module.css';
import { PlusLeft, RuleExecutor, PlusRight } from '../Rule';

class Plus extends Connective {
  toTex(): string {
    return '(' + this.left.toTex() + ' \\oplus ' + this.right.toTex() + ')';
  }
  negated(): Formula {
    return new With(this.left.negated(), this.right.negated());
  }

  equals(that: Formula): boolean {
    return that instanceof Plus && super.equals(that);
  }

  /**
   * Handler for when a branch is selected (i.e. a right rule is applied).
   *
   * Only valid when this is a requirement.
   */
  handleSelect(selection: Formula, executor: RuleExecutor) {
    return () => executor(new PlusRight(this, selection));
  }

  /**
   * Handler for casing (i.e. applying the left rule).
   *
   * Only valid when this is a resource.
   */
  handleSplit(executor: RuleExecutor) {
    return () => executor(new PlusLeft(this));
  }

  render(subgoal: Statement, exec: RuleExecutor): JSX.Element {
    const isRoot = subgoal.hasFormula(this.id);
    const isRequirement = subgoal.hasRequirement(this.id, true);

    const isSelection = isRoot && isRequirement;
    const isSplit = isRoot && !isRequirement;

    return (
      <div
        className={classNames(styles.formula, styles.connective, styles.plus)}
      >
        <Subformula
          onClick={isSelection ? this.handleSelect(this.left, exec) : undefined}
        >
          {this.left.render(subgoal, exec)}
        </Subformula>

        <Operator
          name="⊕"
          onClick={isSplit ? this.handleSplit(exec) : undefined}
        />

        <Subformula
          onClick={
            isSelection ? this.handleSelect(this.right, exec) : undefined
          }
        >
          {this.right.render(subgoal, exec)}
        </Subformula>
      </div>
    );
  }
}

export default Plus;
